import { useCallback, useState } from "react";

import flocknoteStateHooks, { useIsSuperAdmin } from "Flocknote/stateHooks";

import externalNavigate from "Utilities/externalNavigate";
import FnrFetch3 from "../../Utilities/FnrFetch/FnrFetch3";

const useFPTrial = (successCallback) => {
  const [, setShowPeopleSplash] = flocknoteStateHooks.useShowPeopleSplash();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const isSuperAdmin = useIsSuperAdmin();

  const activateFP = useCallback(() => {
    setIsLoading(true);
    const signupForPaymentsCall = new FnrFetch3(`/people/startSubscription`);
    signupForPaymentsCall
        .post()
        .then(() => {
          if (successCallback) {
            setShowPeopleSplash(false);
            setHasError(false);
            successCallback();
          } else {
            var alertInfo = {
              title: "Success!",
              message:
                  "You've upgraded to the <em>Flocknote Complete</em> package and unlocked a robust, integrated database that supercharges your member management and engagement!",
              subtext:
                  "This upgrade is an additional $75 / month and can monitored in the billing section. Questions? Email help@flocknote.com.",
              type: "default",
              buttonAddClass: "green",
              buttonText: "Let's do this!",
              contextObj: {
                refreshFlocknote: () => window.location.reload(),
              },
              onConfirm: "refreshFlocknote",
              hideBackground: true,
            };
            window.fnReactBus.openLegacyAlert(alertInfo);
          }
        })
        .catch((err) => {
          var alertInfo = {};
          if (err.error === "payment_method") {
            alertInfo = {
              title: "Missing Payment Method",
              message:
                  "Whoops! It looks like we do not have a payment method on file for this network. You will need to add one before adding <em>Flocknote Complete</em>.",
              type: "default",
              buttonAddClass: "green",
              buttonText: "Add Payment Method",
              denyButton: "Cancel",
              contextObj: {
                handleMissingPaymentAlertConfirm: (alertObj) => {
                  window.fnReactBus.goToUrl(
                      "billing/collectOneTimePaymentInfo?conv=1"
                  );
                  alertObj.closeAlert();
                },
                handleMissingPaymentAlertClose: () => {},
              },
              onConfirm: "handleMissingPaymentAlertConfirm",
              onClose: "handleMissingPaymentAlertClose",
              hideBackground: true,
            };
            window.fnReactBus.closeUserProfile();
            window.fnReactBus.openLegacyAlert(alertInfo);
          } else {
            setHasError(true);
          }
        })
        .finally(() => setIsLoading(false));
  }, [setShowPeopleSplash, successCallback]);

  const learnMoreFP = () =>
    externalNavigate("https://flocknote.com/full-feature-list/?Complete");

  const ctaText = "Upgrade Now";

  return [
    { ctaText, isLoading, hasError, isSuperAdmin },
    { activateFP, learnMoreFP },
  ];
};

export default useFPTrial;
